export default "/images/fiable-ou-rembourse.svg?81cd731b5d6761c6be3867c3bf87dbac";